export default __webpack_public_path__ + "static/media/in.03bcbbf4.svg";